import * as actionTypes from "../actionTypes";

export const errorPush     = message => ({type: actionTypes.ERROR_PUSH, message});
export const successPush   = message => ({type: actionTypes.SUCCESS_PUSH, message});
export const infoPush      = message => ({type: actionTypes.INFO_PUSH, message});
export const messageRemove = id => ({type: actionTypes.MESSAGE_REMOVE, id});
